/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form } from 'antd';
import VerificationModal from 'components/bank/AGBBank/VerificationModal/VerificationModal';
import { formattedAccountList } from 'components/shared/AccountDropdown';
import { formattedContactAccountList } from 'components/shared/ContactDropdown';
import useDynamicForm from 'hooks/useDynamicForm';
import {
  IOssixProvider,
  LocationState,
} from 'interfaces/otherInterface/dynamicInput';
import { IAccountInfo } from 'interfaces/queries/account';
import LocalTransfer from 'pages/bank/Transfer/LocalTransfer';
import { getAllUserContact } from 'queries/ossix/user/userData';
import { userAccountNumbers } from 'queries/ossix/wallet/requestWallet';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

interface LocalTransferContainerProps {
  isDrawerOpen: any;
  handleCloseOpenDrawer: any;
}

const LocalTransferContainer: React.FC<
  LocalTransferContainerProps
> = ({ isDrawerOpen, handleCloseOpenDrawer }) => {
  const [form] = Form.useForm();
  const location = useLocation();
  const state = location.state as LocationState;
  const [accountNumber, setAccountNumber] = useState();
  const [contactAccount, setContactAccount] = useState<any>();
  const { loadUserAccountNumbers, accountNumbers } =
    userAccountNumbers();
  const { isLoadingContacts, userContactData } = getAllUserContact();
  const [step, setStep] = useState(1);
  const [displaySelectContact, setDisplaySelectContact] =
    useState(false);
  const [selectedProvider, setSelectedProvider] = useState<
    IOssixProvider | undefined
  >();

  const onPrevious = () => setStep((prevStep) => prevStep - 1);
  const onHandleDisplaySelectContact = () =>
    setDisplaySelectContact(true);

  const onHandleCloseSelectContact = () => {
    setDisplaySelectContact(false);
    setContactAccount({
      value: '',
      label: '',
    });
  };

  const accountNumbersInfo: IAccountInfo[] = accountNumbers;
  const selectAccountNumber = formattedAccountList(
    accountNumbersInfo,
  );

  const recipientAccountNumber =
    formattedContactAccountList(userContactData);

  const {
    fields,
    meta,
    handleInputChange,
    loadVerifyAccount,
    onHandleVerifyAccount,
    filterCountry,
    isVerifyAccountSuccess,
    contextHolder,
    onHandleValueChange,
    onHandleTransferConfirmation,
    loadTransferConfirmation,
    transferConfirmationData,
    onPINValuesChange,
    onHandleConfirmTransfer,
    loadSendFundsToGateway,
    userData,
    openPrintTransaction,
    sendFundsToGatewayData,
    onHandleClosePrintPage,
    showVerificationModal,
    verificationData,
    handleVerificationComplete,
    handleVerificationCancel,
  } = useDynamicForm({
    jsonFields: selectedProvider?.Fields as string,
    provider: selectedProvider,
    accountNumber: accountNumber,
    nextStep: setStep,
  });

  return (
    <>
      <LocalTransfer
        step={step}
        selectAccountNumber={selectAccountNumber}
        form={form}
        onPrevious={onPrevious}
        accountNumber={accountNumber}
        setAccountNumber={setAccountNumber}
        loadingAccount={loadUserAccountNumbers}
        recipientAccountNumber={recipientAccountNumber}
        onHandleDisplaySelectContact={onHandleDisplaySelectContact}
        displaySelectContact={displaySelectContact}
        isLoadingContacts={isLoadingContacts}
        contactAccount={contactAccount}
        setContactAccount={setContactAccount}
        onHandleCloseSelectContact={onHandleCloseSelectContact}
        setSelectedProvider={setSelectedProvider}
        selectedProvider={selectedProvider}
        setStep={setStep}
        isDrawerOpen={isDrawerOpen}
        handleCloseOpenDrawer={handleCloseOpenDrawer}
        dynamicFormItem={{
          state: state,
          fields: fields,
          meta: meta,
          handleInputChange: handleInputChange,
          loadVerifyAccount: loadVerifyAccount,
          onHandleVerifyAccount: onHandleVerifyAccount,
          filterCountry: filterCountry,
          isVerifyAccountSuccess: isVerifyAccountSuccess,
          contextHolder: contextHolder,
          onHandleValueChange: onHandleValueChange,
          onHandleTransferConfirmation: onHandleTransferConfirmation,
          loadTransferConfirmation: loadTransferConfirmation,
          transferConfirmationData: transferConfirmationData,
          onPINValuesChange: onPINValuesChange,
          onHandleConfirmTransfer: onHandleConfirmTransfer,
          loadSendFundsToGateway: loadSendFundsToGateway,
          userData,
          openPrintTransaction,
          sendFundsToGatewayData,
          onHandleClosePrintPage,
        }}
      />
      <VerificationModal
        isVisible={showVerificationModal}
        otpRequired={verificationData.otpRequired}
        selfieRequired={verificationData.selfieRequired}
        onComplete={handleVerificationComplete}
        onCancel={handleVerificationCancel}
        loading={loadTransferConfirmation}
      />
    </>
  );
};

export default LocalTransferContainer;
